module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-cascader', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择",
      "expand-trigger": "hover",
      "props": _vm.prop,
      "options": _vm.treeList
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.pointerId),
      callback: function($$v) {
        _vm.pointerId = $$v
      },
      expression: "pointerId"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2754864b","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/component/Datatree.vue
// module id = 1194
// module chunks = 2